module.exports = __webpack_public_path__ + "img/川楝子.30ceecc2.jpg";